export class EstudoQuestionarioEnum {
  static estudoPreliminar: string = "SAE_PRELIMINAR";
  static dadosPessoais: string ="estudo_socioeconomico";
  static grupoFamiliar: string ="detalhamento_grupo_familiar";
}
